const filterForm = document.getElementById('blog-filters');
const blogFeatured = document.querySelector('#blogFeatured');
const searchResults = document.querySelector('#blogResults');
const categoryFilter = document.querySelectorAll('.search-filter-categories');
const blogResultsContainer = document.querySelector('#blogResultsContainer');
const blogNoResults = document.querySelector('#blogNoResults');

if (filterForm) {
    const createPaginationItemElement = (currnetPage, pageNum, listContainer) => {
        const li = document.createElement('li');
        const a = document.createElement('a');

        a.setAttribute('data-page', pageNum);
        a.classList.add('blog-paging');
        if (parseInt(currnetPage) === parseInt(pageNum)) {
            a.classList.add('active');
        }
        a.textContent = pageNum;

        a.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const { page } = e.target.dataset;
            const pageItem = filterForm.querySelector('input[name="page"]');
            // console.log('pageItem',pageItem);

            if(pageItem) pageItem.value = page;
            filterForm.dispatchEvent(new Event('submit', { cancelable: true }));
            blogResultsContainer.scrollIntoView();
        });

        li.appendChild(a);
        listContainer.appendChild(li);
    }

    filterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const currentPage = filterForm.querySelector('input[name="page"]').value;

        const qs = new URLSearchParams(new FormData(e.target)).toString();
        fetch(`/ajax/getArticles/?${qs}`, {
            method: 'GET',
        })
            .then(function (response) {
                if (response.ok) {
                    return response.json();
                }
                return Promise.reject(response);
            })
            .then(function (data) {
                searchResults.innerHTML = data.results.trim();
                blogFeatured.innerHTML = data.featured.trim();

                if (data.countAll == 0 && data.countFeat == 0) {
                    blogNoResults.classList.remove('hidden');
                    blogResultsContainer.classList.add('hidden');
                } else {
                    blogResultsContainer.classList.remove('hidden');
                    blogNoResults.classList.add('hidden');
                }

                if (filterForm.querySelector('.results-filter-overlay').classList.contains('is-visible')) {
                    filterForm.querySelector('.modal-close').click();
                }

                // work out pagination
                const { page, totalPages } = data;
                const blogPaginationContainer = filterForm.querySelector('#blogPaging ul');
                blogPaginationContainer.innerHTML = '';
                if(totalPages > 1) {
                    for (let _p = 1; _p <= totalPages; _p++) {
                        createPaginationItemElement(page, _p, blogPaginationContainer);
                    }
                }
            })
            .catch(function (error) {
                console.warn(error);
            });
    });

    filterForm.dispatchEvent(new Event('submit', { cancelable: true}));
}

document.querySelectorAll('.search-filter-categories').forEach((item) => {
    item.addEventListener('change', (event) => {
        const pageInput = document.querySelector('input[name="page"]');
        pageInput.value = 1;
        filterForm.dispatchEvent(new Event('submit', { cancelable: true}));
    });
});